export enum RoleType {
  TENANT = 'TENANT',
  ADMIN = 'ADMIN',
  AGENCY = 'AGENCY'
}
